import { IonContent, IonPage, IonTitle } from '@ionic/react';
import { ReactElement } from 'react';
import { useParams } from 'react-router';
import { Machine, useGetMachineQuery } from '../../api/graphql/generated';
import { ApplicationsList } from '../../components/application/applications-list';
import { NestedPageHeader } from '../../components/header/page.header';
import { MachineProgramStatus } from '../../components/machine/machine-program-status';
import { useBeaconRouter } from '../../route/route.hooks';

interface MachineApplicationsPageProps {
  teamId: string;
}

interface RouteParams {
  id: string;
  machineId: string;
}

const MachineApplicationsPage = (
  props: MachineApplicationsPageProps
): ReactElement => {
  const { teamId } = props;
  const params = useParams<RouteParams>();
  const { machineId } = params;

  const { data } = useGetMachineQuery({
    variables: { input: { id: machineId, teamId } },
  });

  const { builder } = useBeaconRouter();

  const machine: Machine | undefined = data?.getMachine;
  return (
    <IonPage>
      <NestedPageHeader
        defaultBackRoute={builder.getMachineRoute(teamId, machineId)}
      >
        <IonTitle>
          {machine?.name}
          <div className="subtitle header-program-status">
            <MachineProgramStatus machine={machine} />
          </div>
        </IonTitle>
      </NestedPageHeader>
      <IonContent>
        <ApplicationsList teamId={teamId} machineId={machineId} />
      </IonContent>
    </IonPage>
  );
};

export { MachineApplicationsPage };
